import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signup from "./Signup";
import Login from "./Login";
import Dashboard from "./Dashboard";
import EditProfile from "./EditProfile";
import BrowseQuizzes from "./BrowseQuizzes";
import ViewQuiz from "./ViewQuiz";
import TakeQuiz from "./TakeQuiz";
import QuizCreation from "./QuizCreation";
import EditQuiz from "./EditQuiz";
import EditFlashcards from "./EditFlashcards";
import "./styles.css";
import Navbar from "./Navbar";


function App() {
  return (
      <Router>
        <Navbar />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/browse-quizzes" element={<BrowseQuizzes />} />
            <Route path="view-quiz/:quizId" element={<ViewQuiz />} />
            <Route path="take-quiz/:quizId" element={<TakeQuiz />} />
            <Route path="/create-quiz" element={<QuizCreation />} />
            <Route path="edit-quiz/:quizId" element={<EditQuiz />} />
            <Route path="edit-flashcards/:quizId" element={<EditFlashcards />} />
          </Routes>
        </div>
      </Router>
  );
}

export default App;
